module.exports = __webpack_public_path__ + "static/media/contact-friends.827510c2.png";